import { Bebas_Neue, Cinzel, EB_Garamond, Josefin_Sans, Libre_Baskerville, Newsreader, Oswald, Playfair_Display } from "next/font/google";

// The bookshelf is set in a book face rather than the site's sans.
export const garamond = EB_Garamond({ subsets: ["latin"] });

/** The heading over the sunlit case. */
export const newsreader = Newsreader({ subsets: ["latin"], style: ["normal", "italic"] });

const playfair = Playfair_Display({ subsets: ["latin"] });
const oswald = Oswald({ subsets: ["latin"] });
const cinzel = Cinzel({ subsets: ["latin"] });
const baskerville = Libre_Baskerville({ subsets: ["latin"] });
const josefin = Josefin_Sans({ subsets: ["latin"] });
const bebas = Bebas_Neue({ subsets: ["latin"], weight: "400" });

export type SpineFont = {
  family: string;
  weight: number;
  /** Relative to the default title size, so each face fills the spine alike. */
  scale: number;
  /** The face only has capitals, or looks wrong without them. */
  capitals?: boolean;
  /** Letter spacing in em. */
  tracking: number;
  /** Rough average advance of a title character, in em, set in capitals. */
  capitalAdvance: number;
  /** The same for mixed case; faces that only set capitals leave it out. */
  advance?: number;
};

/**
 * Typefaces a publisher might set a spine in. `spineFor` picks one per book,
 * so neighbouring spines vary the way a real shelf does.
 */
export const SPINE_FONTS: SpineFont[] = [
  { family: garamond.style.fontFamily, weight: 600, scale: 1.15, tracking: 0.1, capitalAdvance: 0.66, advance: 0.44 },
  { family: playfair.style.fontFamily, weight: 700, scale: 1, tracking: 0.1, capitalAdvance: 0.72, advance: 0.5 },
  { family: oswald.style.fontFamily, weight: 500, scale: 1.05, capitals: true, tracking: 0.05, capitalAdvance: 0.5 },
  { family: cinzel.style.fontFamily, weight: 700, scale: 0.95, capitals: true, tracking: 0.05, capitalAdvance: 0.78 },
  { family: baskerville.style.fontFamily, weight: 700, scale: 0.92, tracking: 0.1, capitalAdvance: 0.78, advance: 0.55 },
  { family: josefin.style.fontFamily, weight: 600, scale: 1, capitals: true, tracking: 0.08, capitalAdvance: 0.66 },
  { family: bebas.style.fontFamily, weight: 400, scale: 1.3, capitals: true, tracking: 0.05, capitalAdvance: 0.42 },
];
